import React from 'react';
import Relay from 'react-relay';
import NProgress from 'nprogress';

import { trackPageview } from 'depop/utils/tracking';

export async function loadRoute(loader, cb) {
  const module = await loader;
  cb(null, module.default);
}

export function prepareInfiniteScrollParams(params) {
  return {
    ...params,
    numResults: 24,
  };
}

export function render({ props, element, ...other }) {
  if (props) {
    const { route, routes, location } = props;

    NProgress.done();

    if (__CLIENT__) {
      if (route === routes[routes.length - 1]) {
        if (!route.noTrack) {
          /*
           * Rendering needs to complete before the document title gets updated.
           * We need the new document title before we can accurately track the
           * pageview. Thankfully, it's synchronous, so we can just wait a tick
           * and the title should have changed to the new value.
           */
          setTimeout(() => {
            trackPageview(location);
          }, 4);
        }
      }
    }
    return React.cloneElement(element, props);
  }
}

export let ViewerQueries = {
  viewer: () => Relay.QL`query { viewer }`,
};



// WEBPACK FOOTER //
// ../src/client/router.js